import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  /** Compact icon-only button (for header). */
  variant?: 'icon' | 'inline';
  className?: string;
}

/**
 * Light / Dark mode toggle for the agency portal.
 * Persists preference via ThemeContext (localStorage key `ftos-theme`).
 */
export function ThemeToggle({ variant = 'icon', className = '' }: Props) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = `Switch to ${isDark ? 'light' : 'dark'} mode`;

  if (variant === 'inline') {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleTheme}
        aria-label={label}
        className={`w-full justify-start gap-2 text-muted-foreground hover:text-foreground hover:bg-secondary ${className}`}
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        <span>Appearance · {isDark ? 'Light' : 'Dark'}</span>
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`ftos-header-icon h-8 w-8 rounded-md p-0 ${className}`}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
